/* unplugin-vue-components disabled */import { render } from "./WechatAuth.vue?vue&type=template&id=6ea1c5c6&scoped=true"
import script from "./WechatAuth.vue?vue&type=script&lang=js"
export * from "./WechatAuth.vue?vue&type=script&lang=js"

import "./WechatAuth.vue?vue&type=style&index=0&id=6ea1c5c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea1c5c6"]])

export default __exports__